import { ArrowLeftOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Empty, Space, Upload, UploadProps } from 'antd';
import { FC, useMemo } from 'react';
import { useFolder } from 'services';
import { useActiveFolderId, useSetActiveFolderId } from '../../../store/filepicker.store';

type EmptyFolderProps = {
  searchQuery: string;
  uploadButtonProps?: UploadProps;
};

export const EmptyFolder: FC<EmptyFolderProps> = ({ searchQuery, uploadButtonProps }) => {
  const activeFolderId = useActiveFolderId();
  const setActiveFolder = useSetActiveFolderId();
  const { data: foldersData } = useFolder({
    id: activeFolderId,
  });

  const description = useMemo(() => {
    if (searchQuery.length) {
      return `No files found for "${searchQuery}" keyword`;
    }

    return (
      <div>
        {activeFolderId ? <p>No files selected in this folder, yet...</p> : <p>No uploaded files, yet....</p>}
        <Space direction="vertical" size="large">
          <Upload {...uploadButtonProps}>
            <Button type="primary" icon={<PlusOutlined />}>
              Upload files
            </Button>
          </Upload>
          {activeFolderId && (
            <Button
              type="link"
              icon={<ArrowLeftOutlined />}
              onClick={() => setActiveFolder(foldersData?.folder?.parent_id)}
            >
              Back to parent
            </Button>
          )}
        </Space>
      </div>
    );
  }, [activeFolderId, searchQuery, foldersData?.folder?.parent_id, setActiveFolder, uploadButtonProps]);

  return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={description} />;
};
